import { useEffect, useState } from "react";

const DESKTOP_QUERY = "(min-width: 768px)"; // Tailwind's `md`

/**
 * Whether the viewport is at Tailwind's `md` breakpoint or wider.
 *
 * The page renders its mobile and desktop chrome as sibling trees and hides one
 * with CSS, which is fine for markup but not for a stateful editor: both copies
 * mount, and two live editors writing to the same draft fight each other. Use
 * this to mount the editor in exactly one of the two.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia?.(DESKTOP_QUERY).matches ?? true,
  );

  useEffect(() => {
    const mql = window.matchMedia?.(DESKTOP_QUERY);
    if (!mql) return;
    const onChange = (e: MediaQueryListEvent): void => setIsDesktop(e.matches);
    mql.addEventListener("change", onChange);
    setIsDesktop(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isDesktop;
}
